<app-header [user]="user()" />

<div class="www-pil">
  <app-pillar-top [bannerUrl]="bannerUrl()" [bannerMobUrl]="bannerMobUrl()" />
  <app-pillar-intro [intro]="introText()" />
  @if (btn()) {
    <a
      class="www-pil__btn"
      [routerLink]="[btn()?.url]"
      appGtmClick
      [layer]="{
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'pro education page',
        eventAction: 'select::check',
        eventLabel: 'go to login page::' + '/' + WwwRouteSlug.LOGIN,
        event_name: 'body_button_click',
        module_name: 'check',
        cta_name: 'go to login page',
        link_url: '/' + WwwRouteSlug.LOGIN,
      }"
      >{{ btn()?.text }}</a
    >
  }
  @if (tiles().length) {
    <app-pillar-tiles [tiles]="tiles()" />
  }
  @if (slides().length) {
    <app-pillar-slider [slides]="slides()" />
  }
  <app-pillar-contact-bar />
  <app-home-pillars />
  <app-newsletter-section />
</div>
